import useLocale from '@hellodarwin/core/lib/features/providers/locale-provider';
import { usePlatform } from '@hellodarwin/core/lib/features/providers/platform-provider';
import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import useContentfulApi from '../api';
import { useContentfulDispatch, useContentfulSelector } from '../redux/hooks';
import { fetchPage } from '../redux/pages.slice';
import { selectPageById, selectPagesError, selectPagesStatus, } from '../redux/selectors';
const usePageHandle = () => {
    const { pathname } = useLocation();
    return useMemo(() => `${pathname.split('/')[1]}`, [pathname]);
};
export const usePage = () => {
    const dispatch = useContentfulDispatch();
    const api = useContentfulApi();
    const { selectedLocale } = useLocale();
    const { app } = usePlatform();
    const pageHandle = usePageHandle();
    const error = useContentfulSelector(selectPagesError);
    const loading = useContentfulSelector((state) => selectPagesStatus(state, 'fetchPages'));
    const data = useContentfulSelector((state) => selectPageById(state, pageHandle));
    useEffect(() => {
        if (!pageHandle)
            return;
        if (data || error)
            return;
        dispatch(fetchPage({
            api,
            locale: selectedLocale,
            handle: `${pageHandle}`,
            pageType: app === 'website' ? 'website' : 'client',
        }));
    }, [pageHandle, selectedLocale, app]);
    return { error, loading, data };
};
